var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBgpinline = function SvgBgpinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeWidth: 2,
    d: "M33 59H12a1 1 0 0 1-1-1V21a1 1 0 0 1 1-1h21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0073E6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11 43.5v10m0 0-3-2.82m3 2.82 3-2.82M11 35.5v-10m0 0-3 2.82m3-2.82 3 2.82"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 39.5,
    r: 6,
    fill: "#D6EBFF",
    stroke: "#0073E6",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 39.5,
    r: 1,
    fill: "#D6EBFF",
    stroke: "#0073E6",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M41.412 43c4.208-.013 8.26 1.544 11.329 4.35 3.068 2.807 4.92 6.652 5.174 10.746a9.166 9.166 0 0 1 7.576.6 8.876 8.876 0 0 1 2.88 2.555 8.61 8.61 0 0 1 1.493 3.506 8.515 8.515 0 0 1-.174 3.792 8.656 8.656 0 0 1-1.81 3.362 8.932 8.932 0 0 1-3.1 2.294A9.149 9.149 0 0 1 60.97 75H41.412c-4.353 0-8.527-1.686-11.605-4.686C26.729 67.313 25 63.244 25 59c0-4.243 1.73-8.313 4.807-11.314 3.078-3 7.252-4.686 11.605-4.686"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6FFFC",
    d: "M34 54.5v8.813c0 1.76 3.357 3.187 7.5 3.187 4.142 0 7.5-1.427 7.5-3.187V54.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00877C",
    strokeWidth: 2,
    d: "M34 54.5v8.813c0 1.76 3.357 3.187 7.5 3.187 4.142 0 7.5-1.427 7.5-3.187V54.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6FFFC",
    stroke: "#00877C",
    strokeWidth: 2,
    d: "M41.5 57.5c4.142 0 7.5-1.343 7.5-3s-3.358-3-7.5-3c-4.142 0-7.5 1.343-7.5 3s3.358 3 7.5 3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M41.412 4c4.208-.013 8.26 1.544 11.329 4.35 3.068 2.807 4.92 6.652 5.174 10.746a9.166 9.166 0 0 1 7.576.6 8.876 8.876 0 0 1 2.88 2.555 8.61 8.61 0 0 1 1.493 3.506 8.515 8.515 0 0 1-.174 3.792 8.656 8.656 0 0 1-1.81 3.362 8.932 8.932 0 0 1-3.1 2.294A9.149 9.149 0 0 1 60.97 36H41.412c-4.353 0-8.527-1.686-11.605-4.686C26.729 28.313 25 24.244 25 20c0-4.243 1.73-8.313 4.807-11.314C32.885 5.686 37.059 4 41.412 4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5D6",
    d: "M34 15.5v8.813c0 1.76 3.357 3.187 7.5 3.187s7.5-1.426 7.5-3.187V15.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBF00",
    strokeWidth: 2,
    d: "M34 15.5v8.813c0 1.76 3.357 3.187 7.5 3.187s7.5-1.426 7.5-3.187V15.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5D6",
    stroke: "#FFBF00",
    strokeWidth: 2,
    d: "M41.5 18.5c4.142 0 7.5-1.343 7.5-3s-3.358-3-7.5-3c-4.142 0-7.5 1.343-7.5 3s3.358 3 7.5 3Z"
  })));
};
export default SvgBgpinline;